import React, { useRef, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import MaterialReactTable from "material-react-table";
import {
  Paper,
  Box,
  Button,
  MenuItem,
  IconButton,
  Dialog,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  PersonRemove,
  Visibility as ViewIcon,
} from "@mui/icons-material";
import {
  LoadingPaper,
  LoadingError,
  EmptyPaper,
} from "../../components/LoadingComponents";
import columns from "./H3KBColumns";
import {
  useGetSmartboxes,
  AddSmartbox,
  ViewSmartbox,
} from "../../components/SmartboxComponents";

function H3KB(props) {
  // === web queries ===
  const smartboxesQuery = useGetSmartboxes();

  // === AddSmartbox modal handling ===
  const [openAddSmartbox, setOpenAddSmartbox] = useState(false);
  const handleOpenAddSmartbox = () => {
    setOpenAddSmartbox(true);
  };
  const handleCloseAddSmartbox = () => {
    setOpenAddSmartbox(false);
  };

  // === ViewSmartbox modal handling ===
  const [openViewSmartbox, setOpenViewSmartbox] = useState(false);
  const [selectedSmartbox, setSelectedSmartbox] = useState({});
  const openInEditMode = useRef(false);

  const handleOpenViewSmartbox = (smartbox_id) => {
    // set patient data
    setSelectedSmartbox(smartbox_id);
    setOpenViewSmartbox(true);
  };
  const handleCloseViewSmartbox = () => {
    setOpenViewSmartbox(false);
  };

  const tableColumns = columns;

  return (
    <main style={{ width: "100%" }}>
      <Dialog open={openAddSmartbox}>
        <AddSmartbox closeModal={handleCloseAddSmartbox} />
      </Dialog>

      <Dialog open={openViewSmartbox} fullScreen>
        <ViewSmartbox
          smartbox_id={selectedSmartbox}
          _editMode={openInEditMode.current}
          closeModal={handleCloseViewSmartbox}
        />
      </Dialog>

      <PageTitle title="Gateway" />
      <Paper
        style={{ minHeight: "fitContent", margin: "3vh", maxWidth: "96%" }}
      >
        <Box>
          <Button
            style={{ margin: "15px" }}
            color="primary"
            onClick={handleOpenAddSmartbox}
            variant="contained"
          >
            AGGIUNGI GATEWAY
          </Button>
        </Box>
        {smartboxesQuery.isLoading ? (
          <LoadingPaper />
        ) : smartboxesQuery.isError ? (
          <LoadingError error={smartboxesQuery.error} />
        ) : (
          smartboxesQuery.isSuccess &&
          (smartboxesQuery.data.smartboxes.length === 0 ? (
            <EmptyPaper message={"Nessun gateway disponibile"} />
          ) : (
            smartboxesQuery.isSuccess && (
              <MaterialReactTable
                columns={tableColumns}
                data={smartboxesQuery.data?.smartboxes || []}
                initialState={{
                  density: "compact",
                }}
                enablePagination={true}
                enableBottomToolbar={true}
                enableTopToolbar={false}
                enableSorting={true}
                muiTablePaperProps={{
                  elevation: 0,
                }}
                enableColumnResizing
                enableColumnActions={false}
                enableRowSelection={false}
                enableRowActions={true}
                positionActionsColumn="last"
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                    <IconButton
                      key="view"
                      onClick={() => {
                        openInEditMode.current = false;
                        handleOpenViewSmartbox(row.original.id);
                      }}
                      color="primary"
                    >
                      <ViewIcon />
                    </IconButton>

                    <IconButton
                      key="edit"
                      onClick={() => {
                        openInEditMode.current = true;
                        handleOpenViewSmartbox(row.original.id);
                      }}
                      color="warning"
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton
                      key="delete"
                      onClick={() => {
                        setSelectedSmartbox(row.original);
                        // dissociateFromPatientMutation.mutate(row.original);
                      }}
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                )}
              />
            )
          ))
        )}
      </Paper>
    </main>
  );
}

export default H3KB;
